import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import Alert from './Alert';

interface NotificationProps {
  open: boolean;
  onClose: () => void;
  message: string;
  severity?: 'success' | 'error';
  title?: string;
  autoHideDuration?: number;
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
}

const Notification: React.FC<NotificationProps> = ({
  open,
  onClose,
  message,
  severity = 'success',
  title,
  autoHideDuration = 6000,
  position = 'top-center',
}) => {
  
  useEffect(() => {
    if (open && autoHideDuration) {
      const timer = setTimeout(() => {
        onClose();
      }, autoHideDuration);

      return () => clearTimeout(timer);
    }
  }, [open, autoHideDuration, onClose]);

  if (!open) return null;

  const getPositionStyles = () => {
    switch (position) {
      case 'top-right':
        return { top: '66px', right: '24px' };
      case 'top-left':
        return { top: '66px', left: '24px' };
      case 'bottom-right':
        return { bottom: '24px', right: '24px' };
      case 'bottom-left':
        return { bottom: '24px', left: '24px' };
      case 'top-center':
        return { top: '66px', left: '50%', transform: 'translateX(-50%)' };
      case 'bottom-center':
        return { bottom: '24px', left: '50%', transform: 'translateX(-50%)' };
      default:
        return { top: '66px', right: '24px' };
    }
  };

  const getTransformOrigin = () => {
    switch (position) {
      case 'top-right':
        return 'translateX(100%)';
      case 'top-left':
        return 'translateX(-100%)';
      case 'bottom-right':
        return 'translateX(100%)';
      case 'bottom-left':
        return 'translateX(-100%)';
      case 'top-center':
      case 'bottom-center':
        return 'translateY(-100%)';
      default:
        return 'translateX(100%)';
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        zIndex: 9999,
        opacity: open ? 1 : 0,
        transform: open ? 'translateX(0)' : getTransformOrigin(),
        transition: 'all 0.3s ease-in-out',
        ...getPositionStyles(),
      }}
    >
      <Alert
        severity={severity}
        message={message}
        title={title}
        width="400px"
      />
    </Box>
  );
};

export default Notification; 